import React, { FC } from 'react';
import './footer.scss';

const Footer: FC = () => {
  return (
    <footer>
      🤟🏼 Thanks for visiting! Cheers 🍺
    </footer>
  );
};

export default Footer;